import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'
import { ContentWrapper, NoContentWrapper } from './styles'

interface ContentLessonPros {
  lessonName?: string
  available?: any
}

const ContentLesson: React.FC<ContentLessonPros> = ({ lessonName, available }) => {
  const { profile } = useSelector((state: RootState) => state.student)

  return !available ? (
    <div />
  ) : (
    <ContentWrapper preference="text">
      <NoContentWrapper>
        <h2>Caro(a) {profile.name.split(' ')[0]},</h2>
        <p>
          Este conteúdo está em desenvolvimento e, portanto, encontra-se indisponível no momento.
        </p>

        <p>
          Mas não se preocupe! Em breve traremos uma aula atualizada e ainda mais elaborada para que
          você possa ter um aproveitamento cada vez melhor dos seus estudos! Fique atento(a) à data
          de lançamento do conteúdo: <b>{lessonName}</b>:{' '}
          <b style={{ color: '#076998' }}>{available?.date || 'A definir'}</b>
        </p>

        <p>Desejamos um ótimo estudo, concurseiro(a)! Equipe Direção Concursos</p>
        <p>Equipe Direção Concursos</p>
      </NoContentWrapper>
    </ContentWrapper>
  )
}

export default ContentLesson
